<template>
  <div class="ARNTable">
    <v-container grid-list-md fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Avance por Departamento
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    :data="dataVals"
                    name="Avance por Departamento.csv"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headers"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>

            <v-card-text v-if="dataVals !== null">
              <v-flex xs12>
                <div class="font-weight-bold">
                  Seleccione el departamento del cual quiere cargar los municipios
                </div>
                <v-autocomplete
                  :items="departamentos"
                  label="Departamento"
                  v-model="dept"
                ></v-autocomplete>
              </v-flex>
            </v-card-text>

            <v-card-title class="title" v-if="dept !== null">
              Avance por Municipio ({{ dept }})
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsDept === null">
                  <download-csv
                    :data="dataValsDept"
                    :name="nameDept"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text v-if="dept === 'Version 1 sin muestra'">
              <strong>(*) Solo para "Version 1 sin muestra", se cargan los municipios donde se realizo la encuesta.</strong>
            </v-card-text>

            <v-card-text
              v-if="loadingDept"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headersDept"
                :dataVals="dataValsDept"
                :searchActive="true"
                :key="tableKeyDept"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableExpandWithTotals'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'ARNTable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadTable()
  },

  data: function () {
    return {
      backConf: {
        path: '/arn/rp_tbl/',
        page: 1
      },

      loading: false,
      loadingDept: false,
      progressSize: 70,
      progressWidth: 7,

      headers: [
        {
          text: 'Departamento',
          align: 'left',
          value: 'zona',
          str: 'Totales'
        },
        { text: 'Culminado', value: 'culminado', align: 'center' },
        { text: 'Meta Culminado', value: 'meta_culminado', align: 'center' },
        { text: 'En proceso', value: 'proceso', align: 'center' },
        { text: 'Meta En proceso', value: 'meta_proceso', align: 'center' }
      ],
      labels: {
        'zona': 'Departamento',
        'culminado': 'Culminado',
        'meta_culminado': 'Meta Culminado',
        'proceso': 'En proceso',
        'meta_proceso': 'Meta En proceso'
      },

      headersDept: [
        {
          text: 'Municipios',
          align: 'left',
          value: 'zona',
          str: 'Totales'
        },
        { text: 'Culminado', value: 'culminado', align: 'center' },
        { text: 'Meta Culminado', value: 'meta_culminado', align: 'center' },
        { text: 'En proceso', value: 'proceso', align: 'center' },
        { text: 'Meta En proceso', value: 'meta_proceso', align: 'center' }
      ],
      labelsDept: {
        'zona': 'Municipios',
        'culminado': 'Culminado',
        'meta_culminado': 'Meta Culminado',
        'proceso': 'En proceso',
        'meta_proceso': 'Meta En proceso'
      },

      fields: ['zona', 'culminado', 'proceso'],

      departamentos: null,
      dept: null,
      dataVals: null,
      tableKey: 0,
      dataValsDept: null,
      tableKeyDept: 0
    }
  },

  watch: {
    dept: function () {
      this.municipiosDepto()
    }
  },

  computed: {
    nameDept () {
      return 'Avance por Municipio (' + this.dept + ').csv'
    }
  },

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          departamento: 'all'
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loading = false
          t.tableKey += 1

          let deptos = []
          t.dataVals.forEach(function (dep) {
            deptos.push(dep.zona)
          })
          t.departamentos = deptos
        })
        .catch(function (err) {
          t.dataVals = []
          t.loading = false
          console.error(err)
        })
    },

    /** Carga la tabla de los municipios pertenecientes al departamento
     */
    municipiosDepto () {
      this.loadingDept = true
      this.dataValsDept = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          departamento: this.dept
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsDept = resp.data
          t.loadingDept = false
          t.tableKeyDept += 1
        })
        .catch(function (err) {
          t.dataValsDept = []
          t.loadingDept = false
          console.error(err)
        })
    }
  }
}
</script>
